// removed by extract-text-webpack-plugin
module.exports = {"container":"_29Kv06-F3THS8nu9MsVSRG","grid":"_1TzKGJOiy0aT17yO5EFf0-","image":"j6-rBD0ALi3kdPCy12URb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TextBlock/styles.css
// module id = 366
// module chunks = 0